import { Avatar, Button, Card, Stack, TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import {
  BLACK_COLOR,
  WHITE_COLOR,
  notaColor,
  notaHoverColor,
} from '../../../../../constants/ColorsConst';
import { useNotification } from '../../../../../helpers/Notification';
import MenuCardWidget from '../../../../../widgets/MenuCard';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { saveActExtraEstudiantesAction } from '../ActExtraEstudiantesAction';

const CardActExtraEstudiante = ({
  data,
  estudiante,
  idActividadExtra,
  isDelete = true,
  isNota = true,
  tipoSearch = 1,
  onAsignar,
  onDelete,
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const [nota, setNota] = React.useState(null);
  const [addNota, setAddNota] = React.useState(true);

  React.useEffect(() => {
    if (data) {
      setNota(data.nota);
      setAddNota(!(parseInt(data.nota) > 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSave = () => {
    if (!data.id) {
      return notify('Falta el id de la actividad extra', {
        error: true,
      });
    }
    if (!nota) {
      return notify('Falta la nota', {
        error: true,
      });
    }

    saveActExtraEstudiantesAction(
      { dispatch, notify },
      idActividadExtra,
      data.id,
      {
        nota: nota.length === 1 && parseInt(nota) < 10 ? `0${nota}` : nota,
      },
      null,
    );

    setAddNota(false);
  };

  function onEscape(event) {
    if (event.key === 'Escape' && nota) setNota(null);
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') onSave();
    onEscape(event);
  };

  return (
    <Card
      elevation={4}
      sx={{
        height: '190px',
        mb: 1,
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        sx={{
          fontSize: 14,
          backgroundColor: 'white',
          p: 1,
          borderRadius: 2,
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <Avatar
          alt={estudiante.usuario.perfil.pnombre}
          sx={{ width: 70, height: 70 }}
          src={getFilesArchivos(estudiante.usuario.perfil.avatar)}
        />
        <strong>
          {estudiante.usuario.perfil.pnombre}
          <br />
          {estudiante.usuario.perfil.papellido}
        </strong>
        {estudiante.usuario.perfil.tipoDni}-{estudiante.usuario.perfil.dni}
        <br />
        <label style={{ fontWeight: 'bold', color: 'red', fontSize: '18pt' }}>
          {tipoSearch === 1 ? estudiante.nota : estudiante.definitiva}
        </label>
        {isNota &&
          (addNota ? (
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="center"
            >
              <TextField
                fullWidth
                size="small"
                sx={{ minWidth: '100px' }}
                id={estudiante.id}
                value={nota}
                autoFocus
                onKeyDown={handleKeyDown}
                onChange={(e) => {
                  const text = e.target.value;
                  if (
                    text.length <= 2 &&
                    text <= entidadesStore.ajustes.ponderacion &&
                    text >= 0
                  ) {
                    setNota(text);
                  }
                }}
                type="number"
                InputProps={{
                  inputProps: {
                    min: 0,
                    max: entidadesStore.ajustes.ponderacion,
                  },
                }}
              />
              <BotonComponent
                icon
                tooltip="Guardar"
                saveIcon
                colorIcon={BLACK_COLOR}
                click={onSave}
              />
            </Stack>
          ) : (
            <Button
              size="small"
              sx={{
                minWidth: '60%',
                fontSize: '14pt',
                p: '0px',
                color: WHITE_COLOR,
                fontWeight: 'bold',
                backgroundColor: notaColor(parseInt(data.nota)),
                '&:hover': {
                  color: WHITE_COLOR,
                  backgroundColor: notaHoverColor(parseInt(data.nota)),
                },
              }}
              onClick={() => {
                setAddNota(true);
              }}
            >
              {data.nota ?? '00'}
            </Button>
          ))}
        {isDelete && <MenuCardWidget onDelete={onDelete} />}
        {onAsignar && (
          <BotonComponent click={onAsignar} blue mt={1} text="ASIGNAR" />
        )}
      </Stack>
    </Card>
  );
};

export default CardActExtraEstudiante;
